import { jwtDecode } from 'jwt-decode';
import { User, DecodedJwt } from '../types/user.types';

export function createUser(decodedJwt: DecodedJwt, jwt: string): User {
  return {
    authToken: decodedJwt.authToken,
    displayName: decodedJwt.displayName,
    role: decodedJwt.role,
    pvo: decodedJwt.video,
    pcl: decodedJwt.voice,
    uid: decodedJwt.uid,
    jwt,
  };
}

export function decodeAndSaveToken(jwtParam: string): User {
  const decoded = jwtDecode<DecodedJwt>(jwtParam);
  const user = createUser(decoded, jwtParam);
  saveUser(user);
  return user;
}

export function saveUser(user: User): void {
  const encoded = btoa(JSON.stringify(user));
  localStorage.setItem('mvc', encoded);
}

export function getUser(): User | null {
  try {
    const encoded = localStorage.getItem('mvc');
    if (!encoded) return null;
    return JSON.parse(atob(encoded)) as User;
  } catch {
    return null;
  }
}

export function clearUser(): void {
  localStorage.removeItem('mvc');
}